"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArrayDecoder = void 0;
const simple_errors_1 = require("@simonbackx/simple-errors");
const ObjectData_1 = require("../classes/ObjectData");
class ArrayDecoder {
    constructor(decoder) {
        this.decoder = decoder;
    }
    decode(data) {
        if (Array.isArray(data.value)) {
            return data.value.map((v, index) => new ObjectData_1.ObjectData(v, data.context, data.addToCurrentField(index))).map((d) => d.decode(this.decoder));
        }
        throw new simple_errors_1.SimpleError({
            code: "invalid_field",
            message: `Expected an array at ${data.currentField}`,
            field: data.currentField,
        });
    }
}
exports.ArrayDecoder = ArrayDecoder;
//# sourceMappingURL=ArrayDecoder.js.map